import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  position: relative;
  z-index: 1;
  display: block;
  padding: 30px 5px;
  border: 1px solid ${props => props.theme.palette.general.greyLight};
  background: ${props => props.theme.palette.general.light};
  height: 100%;
  box-sizing: border-box;

  > a {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

export const Image = styled.div`
  > span {
    display: block;
    height: 345px;
    background: no-repeat 50% 50% / contain;
  }
`

export const Name = styled.div`
  display: block;
  margin: 10px 0;
  padding: 0 20px;
  line-height: 1.1;
  font-size: 15px;
  color: ${props => props.theme.palette.general.strong};
  min-height: 2.2em;
`

export const Data = styled.div`
  text-align: center;
`

export const Price = styled.div`
  position: relative;
  margin: 10px 0;
  padding-bottom: 1em;
  color: ${props => props.theme.palette.primary.beta};
  font-size: 14px;

  > .oldPrice {
    color: ${props => props.theme.palette.general.greyDark};
    text-decoration: line-through;
    margin: 0 5px 0 0;
  }

  .regularPrice {
    color: ${props => props.theme.palette.general.strong};
  }

  .startsAt {
    color: ${props => props.theme.palette.general.greyDark};

    > span {
      color: ${props => props.theme.palette.general.strong};
    }
  }
`

export const Flags = styled.div`
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  padding: 15px;

  > span {
    color: ${props => props.theme.palette.general.light};
    text-transform: uppercase;
    font: ${font('default', 'bold', '11px/1')};
    padding: 10px 24px 10px;
    border-radius: 1px;
    margin: 0 5px 3px 0;
    letter-spacing: 1px;

    &.flag-sale {
      background: ${props => props.theme.palette.primary.beta};
    }

    &.flag-new {
      background: ${props => props.theme.palette.primary.alpha};
    }
  }
`

export const AddToWishlistContainer = styled.div`
  position: absolute;
  z-index: 2;
  right: 0;
  top: 0;
  padding: 15px;
`
